// extracted by mini-css-extract-plugin
export default {"dropdowns":"Settings_dropdowns__PbPYY","advanced":"Settings_advanced__i+E5t"};